module.exports = __webpack_public_path__ + "img/kort-17.915ecbec.jpg";